var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal", attrs: { heading: "Recruiter Notes" } }, [
    _c("h4", [
      _vm._v("Create notes for " + _vm._s(_vm.jobApplication.user.full_name))
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: {
          method: "POST",
          action: "/recruiter/active-requisitions/recruiter-notes"
        }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "_csrfToken" },
          domProps: { value: _vm.csrfToken }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "job_application_id" },
          domProps: { value: _vm.jobApplication.id }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "redirect_url" },
          domProps: { value: _vm.currentUrl }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "mb-4" }, [
          _c("label", [_vm._v("Notes")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.jobApplication.recruiter_notes,
                expression: "jobApplication.recruiter_notes"
              }
            ],
            staticClass: "quick-message",
            attrs: { name: "recruiter_notes", rows: "12" },
            domProps: { value: _vm.jobApplication.recruiter_notes },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.jobApplication,
                  "recruiter_notes",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
          _c("div", { staticClass: "cell shrink" }, [
            _c(
              "button",
              {
                staticClass: "button",
                attrs: {
                  disabled: _vm.jobApplication.recruiter_notes === "",
                  type: "submit"
                }
              },
              [_vm._v("Save Notes")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell shrink" }, [
            _c(
              "button",
              {
                staticClass: "button warning",
                attrs: { type: "button" },
                on: { click: _vm.toggleModal }
              },
              [_vm._v("Close")]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b8c244a", { render: render, staticRenderFns: staticRenderFns })
  }
}